import React from "react";
import styles from "./PlanningWeek.module.scss";
import { round } from "../../util/util";

/**
 * A worker of a day: name, hours if any, and the alert icon (as in the site details) when there is an alert.
 */
const WorkerLabel = ({worker}) => <>
  {worker.name}
  {worker.hours > 0 ? " " + round(worker.hours, 1) + "h" : null}
  {worker.alert && <span className={"material-icons " + styles.workerAlert}>error</span>}
</>;

export default WorkerLabel;
